import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, Result } from "../../../../interfaces";
import { Find } from "../../../projects";
import { Adapter } from "../../../../shared/adapter";
import { ProjectsAdapter } from "../../../../adapter/projects-adapter";

export const FETCH_DATA_PROJECTS_REQUEST = 'FETCH_DATA_PROJECTS_REQUEST';
export const FETCH_DATA_PROJECTS_SUCCESS = 'FETCH_DATA_PROJECTS_SUCCESS';
export const FETCH_DATA_PROJECTS_FAILURE = 'FETCH_DATA_PROJECTS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDataProjectsRequest = () => {
    return {
        type: FETCH_DATA_PROJECTS_REQUEST,
    };
};

const fetchDataProjectsSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_PROJECTS_SUCCESS,
        payload: data
    };
};

const fetchDataProjectsFailure = (error: any) => {
    return {
        type: FETCH_DATA_PROJECTS_FAILURE,
        payload: error,
    };
};

export const find = (page: number, pageSize: number, query:Query) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataProjectsRequest());
        try {
            const response = await Find('projects', query, page, pageSize);
            console.log("response", Adapter.from(response.data).to((value) => new ProjectsAdapter(value).adapt()));
            dispatch(fetchDataProjectsSuccess(
                { 
                    meta : response.meta,
                    values : Adapter.from(response.data).to((value) => new ProjectsAdapter(value).adapt()) 
                }
            ));

        } catch (error: any) {
            dispatch(fetchDataProjectsFailure(error.message));
        }
    };
};
